import { gettext } from '@eventbrite/i18n';

/**
 * Accordion section header height is 58px (24px content height + 32px block padding).
 * There is a 16px gap between two sections.
 * When the section is clubbed, we need to move the section up by 32px [16px (gap between sections) + 16px (bottom padding of above section)].
 */
export const CLUBBED_SECTION_MARGIN_TOP_IN_PX = -32;
export const COLLAPSED_SECTION_ANIMATION_DURATION_MS = 300;
export const FROM_TEXT = gettext('From');
